module.exports = __webpack_public_path__ + "media/images/icons/flags/PK-d75e96009b7dae21a86b8ed1078fe790.svg";